import {
  Button,
  ButtonGroup,
  FormControl,
  FormErrorIcon,
  FormErrorMessage,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Stack,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { FC } from 'react';
import currency from 'currency.js';
import { Notification } from '../notification';
import { getDataTracking } from '../../utils';

export interface UseFormInputs {
  editGoal: string;
}

export interface ChangeGoalProps {
  errorMessage?: string;
  goalAmount?: string | number;
  isLoading?: boolean;
  onCancel?: () => void;
  onSubmit: (goalAmount: number) => void;
}
export const ChangeGoal: FC<ChangeGoalProps> = ({
  isLoading,
  errorMessage,
  goalAmount = '',
  onCancel,
  onSubmit,
}) => {
  const {
    formState: { errors },
    register,
    handleSubmit,
    reset: resetForm,
  } = useForm<UseFormInputs>();

  const handleReset = () => {
    resetForm();
    onCancel?.();
  };

  const handleFormSubmit = (data: UseFormInputs) =>
    onSubmit(Number(data.editGoal) * 100);

  return (
    <Stack spacing={4}>
      {errorMessage && <Notification message={errorMessage} status="error" />}
      <form
        aria-label="editGoalForm"
        onSubmit={handleSubmit(handleFormSubmit)}
        onReset={handleReset}
      >
        <FormControl isInvalid={!!errors?.editGoal?.message}>
          <InputGroup>
            <InputLeftElement
              pointerEvents="none"
              color="gray.300"
              fontSize="1.2em"
            >
              $
            </InputLeftElement>
            <Input
              aria-label="Edit Goal"
              id="editGoal"
              type="number"
              {...register('editGoal', {
                required: { value: true, message: 'Must enter goal' },
                min: {
                  value: 1,
                  message: 'Goal must be more than 0',
                },
                max: {
                  value: 999999999,
                  message: 'Goal must be less than 999999999',
                },
              })}
              defaultValue={Math.round(
                Number(
                  currency(Number(goalAmount), {
                    fromCents: true,
                    separator: '',
                    symbol: '',
                  }).format()
                )
              )}
            />
            <InputRightElement>.00</InputRightElement>
          </InputGroup>
          <FormErrorMessage>
            <FormErrorIcon />
            {errors?.editGoal?.message}
          </FormErrorMessage>
        </FormControl>
        <Stack as={ButtonGroup} colorScheme="blue" pt={6}>
          <Button
            type="submit"
            w="full"
            isLoading={isLoading}
            {...getDataTracking('editGoalSave')}
          >
            Save
          </Button>
          <Button
            variant="ghost"
            w="full"
            type="reset"
            {...getDataTracking('editGoalCancel')}
          >
            Cancel
          </Button>
        </Stack>
      </form>
    </Stack>
  );
};
